import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import { memo, useCallback, useContext, useMemo } from 'react';
import { DeviceUISettingsContent } from 'console/shared/contexts/device-ui-settings/types';
import { DragHandle } from '@mui/icons-material';
import { ResponsiveIcon } from 'console/shared/components/icon/responsive';
import { HideIndicator } from 'console/shared/components/indicators/hide';
import { DeviceUISettingsControl } from 'console/shared/contexts/device-ui-settings/control/types';
import { AnimatePresence, motion } from 'framer-motion';
import { wrapping_element_props } from '../utils';
export const DashboardPanelLayout = memo(function DashboardPanelLayout(props) {
    const { children, panel_key, can_hide } = props;
    const { sorting_mode, panels } = useContext(DeviceUISettingsContent);
    const { onVisibilityPanelChange } = useContext(DeviceUISettingsControl);
    const panel = useMemo(() => panels.find((panel) => panel.id === panel_key), [panels, panel_key]);
    const onHidePanel = useCallback(() => {
        if (sorting_mode && can_hide) {
            onVisibilityPanelChange(panel_key);
        }
    }, [panel_key, sorting_mode, can_hide]);
    return (_jsxs(Box, { height: "100%", fontSize: "1.3rem", position: "relative", overflow: "auto", sx: {
            '&.sortable-chosen.sortable-ghost': {
                opacity: 0.2,
            },
        }, children: [sorting_mode && can_hide && (_jsx(HideIndicator, { show: panel?.ui_settings.show, bottom: "initial", right: "initial", top: "8px", left: "20px", onClick: onHidePanel })), sorting_mode && (_jsx(Box, { display: "flex", justifyContent: "flex-end", alignItems: "center", className: "panel-drag-handle", py: 1, children: _jsx(ResponsiveIcon, { fontSize: "1em", color: "action", Icon: DragHandle }) })), _jsx(AnimatePresence, { initial: false, children: _jsx(motion.div, { animate: panel?.ui_settings.show ? 'open' : 'close', variants: wrapping_element_props.variants, transition: wrapping_element_props.transition, children: children }, panel_key) })] }));
});
